import * as tslib_1 from "tslib";
import React from 'react';
import Form from './Form';
import FormState from './FormState';
import Dialog, { DialogContent, DialogTitle, DialogActions, } from 'sinoui-components/Dialog';
import styled from 'styled-components';
var FormDialogWrapper = styled(Dialog)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: ", ";\n  max-width: none;\n"], ["\n  width: ",
    ";\n  max-width: none;\n"])), function (props) {
    return props.size === 'normal'
        ? '70%'
        : props.size === 'big'
            ? '90%'
            : props.size + "px";
});
/**
 * 表单对话框
 */
export default function FormDialog(_a) {
    var open = _a.open, onRequestClose = _a.onRequestClose, title = _a.title, actions = _a.actions, props = tslib_1.__rest(_a, ["open", "onRequestClose", "title", "actions"]);
    return (React.createElement(FormDialogWrapper, { open: open, onRequestClose: onRequestClose, size: props.size },
        title && React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, null,
            React.createElement(Form, tslib_1.__assign({}, props))),
        actions && (React.createElement(DialogActions, null,
            React.createElement(FormState, { formName: props.name }, actions)))));
}
var templateObject_1;
//# sourceMappingURL=FormDialog.js.map